import Swiper from 'swiper';
import { gsap } from "gsap";


import {Navigation, Pagination} from 'swiper/modules';

export default class Highlights{
    
    constructor(element) {
        this._wrapper = element;
        this._btns = this._wrapper.querySelectorAll('.js-highlights-btn');
        this._sliders = this._wrapper.querySelectorAll('.js-highlights-slider');
        this._timelineSlider = this._wrapper.querySelector('.js-highlights-timeline-slider');
        this._left = this._wrapper.querySelector('.js-highlights-left');
        this._right = this._wrapper.querySelector('.js-highlights-right');
        
        this._currSlider = this._sliders[0];
        
        this.timelineSwiper = false;
        
        this.init();
        this.handleTimelineSwiper();
        this.bindEvents();
    }
    
    init(){
        app.nodesEach(this._sliders, (el) => {
            let _pagination = el.querySelector('.swiper-pagination');
            let _swiper = el.querySelector('.swiper');
            let swiper = new Swiper(_swiper, {
                slidesPerView:1,
                loop:false,
                spaceBetween:24,
                pagination: {
                    el: _pagination,
                },
                modules: [Pagination],
                breakpoints:{
                    768:{
                        slidesPerView:2,
                    },
                    1200:{
                        slidesPerView:3
                    }
                }
            });
        });
    }
    
    bindEvents(){
        app.nodesEventListener('click', this._btns, (el,n,e) => {
            this.updateSwipers(n);
        });
        window.addEventListener('resize', app.debounce(() => {

            this.handleTimelineSwiper();
        }));
    }
    
    updateSwipers(n){
        let currentEl = this._wrapper.querySelector('.js-highlights-btn.is-active');
        currentEl.classList.remove('is-active');
        this._btns[n].classList.add('is-active');
        
        gsap.fromTo(this._currSlider, {alpha:1, x:0}, {alpha:0, x:'15%', duration:() => { return window.matchMedia('(max-width:992px').matches ? 0.7 : 1;}, ease: "power4.in", onComplete:() => {
                this._currSlider.classList.add('d-none');
                this._sliders[n].classList.remove('d-none');
                gsap.fromTo(this._sliders[n], {alpha:0, x:'-15%'}, {alpha:1, x:'0%',  duration:() => { return window.matchMedia('(max-width:992px').matches ? 0.7 : 1;}, ease: "power4.out"});
                this._currSlider = this._sliders[n];
            }
        });
    }
    
    handleTimelineSwiper(){
        this.destroyTimelineSwiper();
        if(window.matchMedia('(max-width:992px').matches){
            this.initTimelineSwiper();
        }
    }
    
    initTimelineSwiper(){
        this.timelineSwiper = new Swiper(this._timelineSlider, {
            slidesPerView:1,
            centeredSlides:true,
            modules: [Navigation],
            navigation: {
                nextEl: this._right,
                prevEl: this._left,
            },
        })
        this.timelineSwiper.on('slideChange', () => {
            this.updateSwipers(this.timelineSwiper.activeIndex);
        });
    }
    
    destroyTimelineSwiper(){
        if(this.timelineSwiper){
            this.timelineSwiper.destroy(true , true);
            this.timelineSwiper = false;
        }
    }
    
}